<script setup>
import { useI18n } from 'vue-i18n';
import { getI18nKey } from 'dashboard/routes/dashboard/settings/helper/settingsHelper';

import { BaseTableRow, BaseTableCell } from 'dashboard/components-next/table';
import RowMenu from 'dashboard/components-next/polaris/cards/RowMenu.vue';
import { useSettingsRowMenu } from '../../components/useSettingsRowMenu';

defineProps({
  roles: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['edit', 'delete']);

const { t } = useI18n();
const { rowMenuItems, rowMenuLabel } = useSettingsRowMenu();

const onRowAction = (action, role) => {
  if (action === 'edit') emit('edit', role);
  else emit('delete', role);
};

const getFormattedPermissions = role => {
  return role.permissions
    .map(event => t(getI18nKey('CUSTOM_ROLE.PERMISSIONS', event)))
    .join(', ');
};
</script>

<template>
  <BaseTableRow
    v-for="customRole in roles"
    :key="customRole.id"
    :item="customRole"
  >
    <BaseTableCell>{{ customRole.name }}</BaseTableCell>
    <BaseTableCell wrap>{{ customRole.description }}</BaseTableCell>
    <BaseTableCell wrap>
      {{ getFormattedPermissions(customRole) }}
    </BaseTableCell>
    <BaseTableCell actions>
      <RowMenu
        :label="rowMenuLabel(customRole.name)"
        :items="rowMenuItems()"
        @action="action => onRowAction(action, customRole)"
      />
    </BaseTableCell>
  </BaseTableRow>
</template>
